import IconAdInsert from '@adv-mt/mt-svg-icons/lib/AdInsert'
import IconBell from '@adv-mt/mt-svg-icons/lib/Bell'
import IconBellOutline from '@adv-mt/mt-svg-icons/lib/BellOutline'
import IconCalculator from '@adv-mt/mt-svg-icons/lib/Calculator'
import IconCar from '@adv-mt/mt-svg-icons/lib/Car'
import IconCarAdd from '@adv-mt/mt-svg-icons/lib/CarAdd'
import IconCarAddOutline from '@adv-mt/mt-svg-icons/lib/CarAddOutline'
import IconCarCheckOutline from '@adv-mt/mt-svg-icons/lib/CarCheckOutline'
import IconCertificateOutline from '@adv-mt/mt-svg-icons/lib/CertificateOutline'
import IconChatLinesOutline from '@adv-mt/mt-svg-icons/lib/ChatLinesOutline'
import IconCheckboxChecked from '@adv-mt/mt-svg-icons/lib/CheckboxChecked'
import IconHeartOutline from '@adv-mt/mt-svg-icons/lib/HeartOutline'
import IconNews from '@adv-mt/mt-svg-icons/lib/legacy/News'
import IconWallet from '@adv-mt/mt-svg-icons/lib/legacy/Wallet'
import IconLogOut from '@adv-mt/mt-svg-icons/lib/LogOut'
import IconMail from '@adv-mt/mt-svg-icons/lib/Mail'
import IconMenu from '@adv-mt/mt-svg-icons/lib/Menu'
import IconMotoAddOutline from '@adv-mt/mt-svg-icons/lib/MotoAddOutline'
import IconPlay from '@adv-mt/mt-svg-icons/lib/Play'
import IconSearch from '@adv-mt/mt-svg-icons/lib/Search'
import IconSettings from '@adv-mt/mt-svg-icons/lib/Settings'
import IconShare from '@adv-mt/mt-svg-icons/lib/Share'
import IconStarFull from '@adv-mt/mt-svg-icons/lib/StarFull'
import IconStarEmpty from '@adv-mt/mt-svg-icons/lib/StartEmpty'
import IconUser from '@adv-mt/mt-svg-icons/lib/User'
import IconUserLargeOutline from '@adv-mt/mt-svg-icons/lib/UserLargeOutline'

export const icons = {
  'ad-moto': IconMotoAddOutline,
  'ad-car': IconCarAddOutline,
  'ad-insert': IconAdInsert,
  'star-empty': IconStarEmpty,
  bell: IconBell,
  bellCheck: IconBellOutline,
  calculator: IconCalculator,
  car: IconCar,
  carAdd: IconCarAdd,
  carCheck: IconCarCheckOutline,
  certificationLabel: IconCertificateOutline,
  checkbox: IconCheckboxChecked,
  comments: IconChatLinesOutline,
  logout: IconLogOut,
  mail: IconMail,
  menu: IconMenu,
  news: IconNews,
  play: IconPlay,
  search: IconSearch,
  settings: IconSettings,
  share: IconShare,
  starFull: IconStarFull,
  user: IconUser,
  userFilled: IconUserLargeOutline,
  wallet: IconWallet,
  heartFull: IconHeartOutline
}
